/**
 * 创建人：但志强
 * 时间：2019-6-01
 * 描述：选择日期组件
 * 使用说明: 参考 sw-date 配置应用说明文档 
 * 更新记录: 
 */
import { Component, OnInit, Input, forwardRef, Output, EventEmitter, HostListener, ElementRef, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import jeDate from '../../../../../assets/Scripts/jedate-6.5.0/src/jedate.js'

declare var $: any;

export const EXE_COUNTER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SwDateComponent),
  multi: true
};

/**
 * 日期控件 sw-date
 */
@Component({
  selector: 'sw-date',
  providers: [EXE_COUNTER_VALUE_ACCESSOR],
  templateUrl: './sw-date.component.html',
  styleUrls: ['./sw-date.component.css']
})
export class SwDateComponent implements OnInit {
 
  /**
   * 主键id
   * @ignore
   */
  jeDateId: string; 

  /**
   * 面板组件
   * @ignore
   */
  jeDateIdShow: string;

  /**
   * @ignore
   * 日期数据
   */
  _jeDate: any;

  /**
   * 背景颜色
   * @ignore
   */
  bgColor: string 

  /**
   * 主题颜色 不可用
   * @ignore
   */
  skinCell: string = "jedateblue"   
  
  /**
   * 占位符
   * 
   */
  @Input() placeholder: string = "" 
  
  /**
   * 日期格式 
   * 
   */
  @Input() format: string = "YYYY-MM-DD hh:mm"      
  
   /**
    * 最小日期 或者 "1900-01-01" 或者 "10:30:25"
    **/ 
  @Input() minDate: string = "1900-01-01 00:00:00"   

  /**
   * 最大日期 或者 "2099-12-31" 或者 "16:35:25"
   */
  @Input() maxDate: string = "2099-12-31 23:59:59"  
  
  /**
   * 是否显示为固定日历，为false的时候固定显示
   */
  @Input() isShow: boolean = true 
  
  /**
   * 是否为双面板，为false是展示双面板
   */
  @Input() multiPane: boolean = true     
  
  /**
   * 是否为选中日期后关闭弹层，为false时选中日期后关闭弹层
   */
  @Input() onClose: boolean = true   
  
  /**
   * 是否进行区域选择 
   */
  @Input() range: boolean = false   
  
  /**
   * 是否内部触发事件，默认为内部触发事件
   */
  @Input() trigger: 'click'    
  
  /**
   * 自定义日期弹层的偏移位置，长度为0 ，弹层自动查找位置
   */
  @Input() position: any = []                                               

  /**
   * 有效日期与非有效日期， 例如 ["0[4-7]$,1[1-5]$,2[58]$",true]
   */
  @Input() valiDate: any = []                                               

  /**
   * 是否开启时间选择
   */
  @Input() isTime: boolean = true      
  
  /**
   * 是否显示清空
   */
  @Input() isClear: boolean = true       
  
  /**
   * 是否显示今天或本月
   */
  @Input() isToday: boolean = true    
  
  /**
   * 是否显示农历节日
   */
  @Input() festival: boolean = false                                                 

  /**
   * 是否禁止定位 ，为true时定位在输入框，为false时居中定位
   */
  @Input() fixed: boolean = true          
  
  /**
   * 给日期左标注 ['2019-01-01','2019-01-02']
   */
  @Input() marks: null               
  
  /**
   * 左边快捷菜单  
   */
  @Input() shortcut: any = []     
  
  /**
   * 禁用属性 默认为false   
   */       
  @Input() disabled: boolean = false   
  
  /**
   * 双面板下，是否支持开始日期和结束日期相同，默认false不支持， true为支持 //zll添加
   */
  @Input() isSameStartAndEnd:boolean = false;
  
  /**
   * 选中事件抛出
   */
  @Output() change = new EventEmitter()

  /**
   * 鼠标放到输入框上显示日期
   */
  dateValue:string = ""

  /**
   * 输入框
   */
  @ViewChild('input') input:ElementRef;
  
  /**
   * 皮肤背景
   * @ignore
   */
  skinColor1 = [
    { className: "skin-blue", des: "蓝", baseColor: "#00c0ef" },
    { className: "skin-blue-dark", des: "蓝-深", baseColor: "#00c0ef", active: true },
    { className: "skin-blue-light", des: "蓝-浅", baseColor: "#00c0ef" },
    { className: "skin-green", des: "绿", baseColor: "#18bc9c" },
    { className: "skin-green-dark", des: "绿-深", baseColor: "#18bc9c" },
    { className: "skin-green-light", des: "绿-浅", baseColor: "#18bc9c" },
    { className: "skin-red", des: "红", baseColor: "#e74c3c" },
    { className: "skin-red-dark", des: "红-深", baseColor: "#e74c3c" },
    { className: "skin-red-light", des: "红-浅", baseColor: "#e74c3c" },
    { className: "skin-yellow", des: "黄", baseColor: "#f39c12" },
    { className: "skin-yellow-dark", des: "黄-深", baseColor: "#f39c12" },
    { className: "skin-yellow-light", des: "黄-浅", baseColor: "#f39c12" },
    { className: "skin-default", des: "默认", baseColor: "#000" },
    { className: "skin-default-dark", des: "默认-深", baseColor: "#000" },
  ];

   /**
    * @ignore
    */
  constructor(
    private el: ElementRef
  ) {
    // setInterval(()=>{
    this.jeDateId = "jedate" + Math.random().toString().split(".")[1];
    this.jeDateIdShow = "jeDateIdShow" + Math.random().toString().split(".")[1];
    // },100)
  }

 
  /**
   * @ignore
   */
  ngOnInit() {
    let cc = localStorage.getItem('skinColor')
    if (cc) {
      this.bgColor = this.skinColor1.filter(item => item.className == cc)[0].baseColor
    } else {
      this.bgColor = "#00c0ef"
    }
  }

  /**
   * @ignore
   */
  ngAfterViewInit(): void {
    this.locaJeDate();
    //监听 myModalBody 盒子的滚动条事件
    this.myModalBodyScroll() 
    //监听 myWrapCont 盒子的滚动条事件
    this.myWrapContScroll()  
  }

  ngOnDestroy(): void {
    //移除 myModalBody 盒子的滚动条事件
    this.myModalBodyRmScroll() 
    //移除 myWrapCont 盒子的滚动条事件
    this.myWrapContRmScroll()  
  }

  /**
   * @ignore
   */
  jedate = {
    // skinCell: "jedateblue",                                          //日期风格样式，默认蓝色
    format: "YYYY-MM-DD hh:mm:ss",                                   //日期格式
    minDate: "1900-01-01 00:00:00",                                  //最小日期 或者 "1900-01-01" 或者 "10:30:25"
    maxDate: "2099-12-31 23:59:59",                                  //最大日期 或者 "2099-12-31" 或者 "16:35:25"
    language: {
      name: "cn",
      month: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
      weeks: ["日", "一", "二", "三", "四", "五", "六"],
      times: ["小时", "分钟", "秒数"],
      titText: "请选择日期时间",
      clear: "清空",
      today: "今天",
      yes: "确定",
      close: "关闭",
    },
    isShow: true,                                                     //是否显示为固定日历，为false的时候固定显示
    multiPane: true,                                                  //是否为双面板，为false是展示双面板
    onClose: true,                                                    //是否为选中日期后关闭弹层，为false时选中日期后关闭弹层
    range: null,                                                      //如果不为空，则会进行区域选择 例如‘至’ ，‘~’ ，‘To’
    trigger: 'click',                                                 //是否内部触发事件，默认为内部触发事件
    position: [],                                                     //自定义日期弹层的偏移位置，长度为0 ，弹层自动查找位置
    valiDate: [],                                                     //有效日期与非有效日期， 例如 ["0[4-7]$,1[1-5]$,2[58]$",true]
    isinitVal: false,                                                 //是否初始化事件，默认不初始化事件       
    initDate: {},                                                     //初始化时间 ，加减 天 时 分
    isTime: true,                                                     //是否开启时间选择
    isClear: true,                                                    //是否显示清空
    isToday: true,                                                    //是否显示今天或本月
    festival: false,                                                  //是否显示农历节日
    fixed: true,                                                      //是否禁止定位 ，为true时定位在输入框，为false时居中定位
    zIndex: 9990,                                                     //弹出层的层级高度
    marks: null,                                                      //给日期左标注
    isSameStartAndEnd: false,                                            //双面板下，是否支持开始日期和结束日期相同，默认false不支持， true为支持 //zll添加
    clearfun: (elem, val) => { },                                   //清除日期后的回调， elem当前输入框ID ,val当前选择的值
    donefun: (obj) => { },                                         //点击确定后回调，obj包含(elem当前输入框ID ，val当前选择的值，date当前的日期值)
    success: (elem) => { }                                         //层弹出后的成功回调方法，elem当前输入框ID
  }

  /**
   * 重新加载日期控件
   */
  locaJeDate() {
    let Id = this.jeDateId;
    if (!this.isShow)
      Id = this.jeDateIdShow
    if (this.range) {
      jeDate("#" + Id, {
        theme: { bgcolor: this.bgColor, pnColor: this.bgColor },
        // skinCell: this.skinCell,                                          //日期风格样式，默认蓝色
        format: this.format,                                 //日期格式
        range: '至',
        minDate: this.minDate,                                  //最小日期 或者 "1900-01-01" 或者 "10:30:25"
        maxDate: this.maxDate,                                  //最大日期 或者 "2099-12-31" 或者 "16:35:25"
        isShow: this.isShow,                                                    //是否显示为固定日历，为false的时候固定显示
        multiPane: this.multiPane,                                                 //是否为双面板，为false是展示双面板
        onClose: this.onClose,                                                   //是否为选中日期后关闭弹层，为false时选中日期后关闭弹层
        trigger: 'click',                                                //是否内部触发事件，默认为内部触发事件
        position: this.position,                                                    //自定义日期弹层的偏移位置，长度为0 ，弹层自动查找位置
        isTime: this.isTime,                                                    //是否开启时间选择
        isClear: this.isClear,                                                   //是否显示清空
        isToday: this.isToday,                                                   //是否显示今天或本月
        valiDate: this.valiDate,
        festival: this.festival,                                                 //是否显示农历节日
        fixed: this.fixed,                                                     //是否禁止定位 ，为true时定位在输入框，为false时居中定位
        zIndex: 9990,                                                    //弹出层的层级高度
        shortcut: this.shortcut,
        marks: this.marks,                                                     //给日期左标注
        isSameStartAndEnd: this.isSameStartAndEnd,                                            //双面板下，是否支持开始日期和结束日期相同，默认false不支持， true为支持 //zll添加
        clearfun: (elem, val) => { this.clearFunDate(elem, val) },                                        //清除日期后的回调， elem当前输入框ID ,val当前选择的值
        donefun: (obj) => { this.doneFunDate(obj) },                                              //点击确定后回调，obj包含(elem当前输入框ID ，val当前选择的值，date当前的日期值)
        success: (elem) => {}                                              //层弹出后的成功回调方法，elem当前输入框ID
      });
    } else {
      jeDate("#" + Id, {
        theme: { bgcolor: this.bgColor, pnColor: this.bgColor },
        // skinCell: this.skinCell,                                          //日期风格样式，默认蓝色
        format: this.format,                                 //日期格式
        minDate: this.minDate,                                  //最小日期 或者 "1900-01-01" 或者 "10:30:25"
        maxDate: this.maxDate,                                  //最大日期 或者 "2099-12-31" 或者 "16:35:25"
        isShow: this.isShow,                                                    //是否显示为固定日历，为false的时候固定显示
        multiPane: this.multiPane,                                                 //是否为双面板，为false是展示双面板
        onClose: this.onClose,                                                   //是否为选中日期后关闭弹层，为false时选中日期后关闭弹层
        trigger: 'click',                                                //是否内部触发事件，默认为内部触发事件
        valiDate: this.valiDate,
        position: this.position,                                                    //自定义日期弹层的偏移位置，长度为0 ，弹层自动查找位置
        isTime: this.isTime,                                                    //是否开启时间选择
        isClear: this.isClear,                                                   //是否显示清空
        isToday: this.isToday,                                                   //是否显示今天或本月
        festival: this.festival,                                                 //是否显示农历节日
        fixed: this.fixed,                                                     //是否禁止定位 ，为true时定位在输入框，为false时居中定位
        zIndex: 9990,                                                    //弹出层的层级高度
        shortcut: this.shortcut,
        marks: this.marks,                                                     //给日期左标注
        isSameStartAndEnd: this.isSameStartAndEnd,                                            //双面板下，是否支持开始日期和结束日期相同，默认false不支持， true为支持 //zll添加
        clearfun: (elem, val) => { this.clearFunDate(elem, val) },                                        //清除日期后的回调， elem当前输入框ID ,val当前选择的值
        donefun: (obj) => { this.doneFunDate(obj) },                                              //点击确定后回调，obj包含(elem当前输入框ID ，val当前选择的值，date当前的日期值)
        success: (elem) => {}                                              //层弹出后的成功回调方法，elem当前输入框ID
      });
    }
  }


  /**
   * 清除事件
   * @ignore
   */
  clearFunDate(elem, val) {
    this.JeDateVal = val;
    this.dateValue = ""
  }

  /**
   * 构子
   * @ignore
   */
  ngOnChanges(event): void {
    let Id = this.jeDateId;
    if (!this.isShow)
      Id = this.jeDateIdShow
    if ($("#" + Id).length > 0) {
      this.locaJeDate();
    }

  }

  /**
   * 点击确定后回调
   * @ignore
   */
  doneFunDate(obj) {
    //当选择月份之后再来选择日期的时候,默认是从当前月份的一月份开始选择的,但是日期是--"2019-04-undefined 12:01至2019-04-18 00:00",手动将undefined替换成01
    this.JeDateVal = obj.val;
    this.dateValue = obj.val
    this.change.emit(this.JeDateVal);
  }



  /**
   *  @ignore
   */
  get JeDateVal() {
    return this._jeDate;
  }

    /**
   *  @ignore 
   */
  set JeDateVal(value: any) {
    this._jeDate = this.dateFormat(value);
    if(this._jeDate!=null && this._jeDate !=undefined){
      let jedateVal = this._jeDate.replace("#",' 至 ')
      $("#" + this.jeDateId).val(jedateVal);
    }else{
      $("#" + this.jeDateId).val(value);
    }
    this.propagateChange(this._jeDate);
  }
  /**
   *  @ignore
   */
  propagateChange = (_: any) => {
  };

  /**
   * @ignore
   * 该方法用于将模型中的新值写入视图或 DOM 属性中。
  */
  writeValue(value: any) {
    this.JeDateVal = value;
  }

  /**
   * @ignore
   * @param fn 
   * 设置当控件接收到 change 事件后，调用的函数
   */
  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  /**
   * @ignore
   * @param fn 
   * 设置当控件接收到 touched 事件后，调用的函数
   */
  registerOnTouched(fn: any) { }

/** 
 * 将传入的参数日期格式化
 * @param {string} val 该参数具体说明文档参考
 * @returns jeDt  处理后的日期格式
 * @example
 * @ignore
 */
  dateFormat(val:string) {
    if (val != null && val != "" && val != undefined) {
      let jeDt = "";
      let dts = [];
      dts = val.split("至");
      //将时间进行排序
      this.sort(dts)
      dts.forEach(el => {
        let date = this.format;
        let dt = new Date(el);
        if (dt.getDate().toString() == "NaN" || dt.getDate().toString() == "undefined" || dt.getDate().toString() == "null") {
          return jeDt += el + "#";
        }
        // 处理年份
        if (date.indexOf("YYYY") >= 0) {
          date = date.replace("YYYY", dt.getFullYear().toString())
        }
        // 处理月份
        if (date.indexOf("MM") >= 0) {
          let MM = (dt.getMonth() + 1);
          // 补零操作
          if (MM <= 9)
            date = date.replace("MM", "0" + MM.toString())
          else
            date = date.replace("MM", MM.toString())
        }
        // 处理天
        if (date.indexOf("DD") >= 0) {
          let DD = dt.getDate();
          // 补零操作
          if (DD <= 9)
            date = date.replace("DD", "0" + DD.toString())
          else
            date = date.replace("DD", DD.toString())
        }
        // 处理小时
        if (date.indexOf("hh") >= 0) {
          let hh = dt.getHours();
          // 补零操作
          if (hh <= 9)
            date = date.replace("hh", "0" + hh.toString())
          else
            date = date.replace("hh", hh.toString())
        }
        // 处理分钟
        if (date.indexOf("mm") >= 0) {
          let mm = dt.getMinutes();
          // 补零操作
          if (mm <= 9)
            date = date.replace("mm", "0" + mm.toString())
          else
            date = date.replace("mm", mm.toString())
        }
        // 处理秒钟
        if (date.indexOf("ss") >= 0) {
          let ss = dt.getSeconds();
          // 补零操作
          if (ss <= 9)
            date = date.replace("ss", "0" + ss.toString())
          else
            date = date.replace("ss", ss.toString())
        }
        jeDt += date + "#";
      })
      jeDt = jeDt.substring(0, jeDt.length - 1)
      return jeDt;
    }
  }

  //对数组中的时间进行从小到大进行排序
  sort(dateArr){
    dateArr.sort(function(a,b){
      return new Date(a).getTime() - new Date(b).getTime()
    })
  }

  @HostListener('document:mousewheel', ['$event']) onmousewheel(event) {
    //鉴定全屏键盘事件 如果是滚轮滚动触发
    //日期控件弹出层消失
    // var elem = $("#jedate")[0], tipelem = $("#jedatetipscon")[0];
    // elem && document.body.removeChild(elem);
    // tipelem && document.body.removeChild(tipelem);
  } 
 /*  @HostListener('window:scroll', ['$event'])
  public windowScrolled($event) {
    
    //日期控件弹出层消失
    var elem = $("#jedate")[0], tipelem = $("#jedatetipscon")[0];
    elem && document.body.removeChild(elem);
    tipelem && document.body.removeChild(tipelem);
  } */

  @HostListener('document:dragstart', ['$event'])
  ondragstart($event) {
    //日期控件弹出层消失
    const clickInside1 = this.el.nativeElement.contains(event.target)
    let clickInside2
    if($("#jedate")[0]){
      clickInside2 = $("#jedate")[0].contains(event.target)
    }
    if(clickInside1 || clickInside2) {
    } else {
      var elem = $("#jedate")[0], tipelem = $("#jedatetipscon")[0];
      elem && document.body.removeChild(elem);
      tipelem && document.body.removeChild(tipelem);
    }
    
  }

  //监听 myWrapCont 盒子的滚动条事件,滚动就让日期控件消失
  myWrapContScroll(){
    let _scroll = $("#myWrapCont")[0]
    if(_scroll) {
      _scroll.addEventListener('scroll',()=>{
        var elem = $("#jedate")[0], tipelem = $("#jedatetipscon")[0];
        elem && document.body.removeChild(elem);
        tipelem && document.body.removeChild(tipelem);
      })
    }
  }

  //页面销毁时,移除此事件
  myWrapContRmScroll(){
    let _scroll = $("#myWrapCont")[0]
    if(_scroll){
      _scroll.removeEventListener('scroll',this.myWrapContScroll)

    }
  }

  //监听 myModalBody 盒子的滚动条事件,滚动就让日期控件消失
  myModalBodyScroll(){
    let _scroll = $("#myModalBody")[0]
    if(_scroll) {
      _scroll.addEventListener('scroll',()=>{
        var elem = $("#jedate")[0], tipelem = $("#jedatetipscon")[0];
        elem && document.body.removeChild(elem);
        tipelem && document.body.removeChild(tipelem);
      })
    }
  }

  //页面销毁时,移除此事件
  myModalBodyRmScroll(){
    let _scroll = $("#myModalBody")[0]
    if(_scroll){
      _scroll.removeEventListener('scroll',this.myModalBodyScroll)
    }
  }
  
  //点击右侧三角图标,一定会先触发 blur , 不管原来有没有下拉框,点击之后一定没有了, 所以只需要原来没有就展开就行
  switchDropmenu(event){
    let jedateDom = document.getElementsByClassName("jedate")
    if(jedateDom[0] && jedateDom[0]['id'] == 'jedate'){
      //如果已经有日期面板,就销毁面板 此时下拉框已销毁
      document.removeChild($("#jedate")[0])
    } else {
      //如果没有,就展示面板
      this.input.nativeElement.click()
    }
  }
}